<div *ngIf="!report;else main_content">
  <app-loading-spinner></app-loading-spinner>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="mt-5 detail-name" style="font-size:x-large;">
        This report may take a minute to generate.
      </div>
    </div>
  </div>
</div>

<ng-template #main_content>
  <div class="ssocc">
  <div class="speaking-score-outer-container">
    <div class="speaking-score-inner-container sparc-title-container text-center">
      <div class="speaking-score-sparc-line h4">SPARC</div>
      <div class="speaking-score-long-line h6">Speaking Proficiency&nbsp;Score</div>
    </div>
    <div class="speaking-score-inner-container speaking-score-number-container">
      <h6 class="speaking-score-text">CLASS AVERAGE</h6>
      <div class="speaking-score-number-box">
        <div *ngIf="showSPARCData" class="h1 speaking-score-number">{{ currentClassAverageSparc }}</div>
        <h1 *ngIf="!showSPARCData" class="speaking-score-text" style="padding-bottom: 0">--</h1>
        <div *ngIf="classAvgIncreased" class="speaking-score-icon"
          ngbTooltip="Class average has gone up since last month." placement="end"
          tooltipClass="custom-tooltip-styling"><i class="fas fa-caret-up h1" style="color: #79C045;"></i></div>
        <div *ngIf="classAvgDecreased" class="speaking-score-icon"
          ngbTooltip="Class average has gone down since last month." placement="end"
          tooltipClass="custom-tooltip-styling"><i class="fas fa-caret-down h1" style="color: #FD362C;"></i></div>
      </div>
    </div>
    <div class="speaking-score-inner-container speaking-score-progress-chart-container">
      <h6 class="speaking-score-text">CLASS AVERAGE OVER TIME</h6>
      <div class="speaking-score-progress-chart-box">
        <canvas *ngIf="showSPARCData" #speakingScoreChart>{{ chart }}</canvas>
        <h6 *ngIf="!showSPARCData" class="speaking-score-text" style="padding-bottom: 0; width: 65%">
          No data available yet.<br>Keep using Joy School English to get enough speaking opportunities to generate data.
        </h6>
      </div>
    </div>
  </div>
  </div>

  <!-- <table class="table" *ngIf="report.MissedSkills">
      <thead>
        <th>Top missed skills</th>
        <th class="student-table">Level</th>
        <th class="student-table">Unit</th>
        <th class="student-table">Number of students</th>
      </thead>
      <tbody *ngIf="report.MissedSkills.length == 0">
        <tr>
          <td colspan="3"><i>No top missed skills.</i></td>
        </tr>
      </tbody>
      <tbody *ngIf="report.MissedSkills.length > 0">
        <tr *ngFor="let missedSkill of report.MissedSkills">
          <td>
            {{ displaySkill(missedSkill.SkillType, missedSkill.SkillConcept) }}
          </td>
          <td class="student-table">
            {{ getCourseCodeAsLevel(missedSkill.CourseCode) }}
          </td>
          <td class="student-table">
            {{ missedSkill.UnitNumber }}
          </td>
          <td class="student-table">
            <span [ngbTooltip]="missedSkill.Students.join(', ')">{{ missedSkill.Missed }} / {{missedSkill.Total}}</span>
          </td>
        </tr>
      </tbody>
    </table> -->

  <app-class-students-report [students]="report.Students" [organizationId]="organizationID" [classId]="classID"
    [clickable]="true" [showScores]="true"></app-class-students-report>

</ng-template>